import { useIsMutating, useMutation, useQueryClient } from "@tanstack/react-query";
import { formatFiltersV2MetaToApiFormat } from "PFApp/components/filters_v2";
import { savedFiltersKeys } from "PFCore/hooks/queries/filters/query_keys";
import { FetchLatestFiltersParams, saveLatestFilters } from "PFCore/services/filters";
import { MutationOptions } from "PFTypes";
import { FiltersMetaV2, FilterV2WithValueOnly } from "PFTypes/filters_v2";
import { SavedFiltersV2 } from "PFTypes/saved_filters";

export const useSaveLatestFilters = (
  params: FetchLatestFiltersParams,
  {
    onSuccess,
    ...queryParams
  }: MutationOptions<FiltersMetaV2<FilterV2WithValueOnly> | undefined, SavedFiltersV2> = {}
) => {
  const cache = useQueryClient();

  const mutationKey = savedFiltersKeys.latestFilters(params);
  const isMutating = useIsMutating({ mutationKey });

  const mutation = useMutation({
    mutationKey,
    mutationFn: (updatedFilters?: FiltersMetaV2<FilterV2WithValueOnly>) =>
      saveLatestFilters({
        ...params,
        ...formatFiltersV2MetaToApiFormat(updatedFilters || {})
      }),
    onSuccess: (freshLatestFilters, ...args) => {
      cache.setQueryData(savedFiltersKeys.latestFilters(params), freshLatestFilters);
      onSuccess?.(freshLatestFilters, ...args);
    },
    ...queryParams
  });

  return {
    ...mutation,
    isMutating
  };
};
